import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        url    : '#',
        text   : '',
        show   : false,
        admin  : false,
        icon   : ''
    }
});